import React from "react";
import PageWithHeader from "../common/PageWithHeader";
import { Box, IconButton, Typography } from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import FeedbackSurveyResponses from "./FeedbackSurveyResponses";
import { useRouter } from "../../hooks/useRouter";
import { useParams } from "react-router-dom";

const AdminFeedbackSurvey: React.FC = () => {
  const params = useParams();
  const router = useRouter();

  return (
    <PageWithHeader>
      <Box sx={{ p: 3, maxWidth: 1400, margin: "0 auto" }}>
        {/* Header */}
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            mb: 3,
          }}
        >
          <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
            <IconButton onClick={() => router.push("/reviews/admin")}>
              <ArrowBackIcon />
            </IconButton>
            <Typography variant="h4">360° Feedback Review (Admin)</Typography>
          </Box>
        </Box>

        <FeedbackSurveyResponses subjectUserId={params?.uuid ?? ""} admin />
      </Box>
    </PageWithHeader>
  );
};

export default AdminFeedbackSurvey;
